// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import "@/theme.js"
import '@/style/base.scss'
import '@/assets/font/iconfont.css'
// 按需
import '@/elementUI'

// 全局
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

import ErrorPlugin from '@/config/error'
Vue.use(ErrorPlugin)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#tjnm',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js